import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core'; // For translations

@Component({
  selector: 'app-ng-select-form-field',
  templateUrl: './ng-select-form-field.component.html',
})
export class NgSelectFormFieldComponent implements OnInit {
  @Input() control: FormControl | any = null; // The form control to manage
  @Input() controlName: string = '';
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() items: any[] = []; // For ng-select
  @Input() bindLabel: string = '';
  @Input() bindValue: string = '';
  @Input() typeahead: any = '';
  @Output() change = new EventEmitter<any>(); // Emit changes to parent
  @Output() scrollToEnd = new EventEmitter<void>(); // Emit scrollToEnd event to parent

  constructor(public translate: TranslateService) { }

  ngOnInit(): void { }

  isControlValid(): boolean {
    return this.control ? this.control.valid && this.control.touched : false;
  }

  isControlInvalid(): boolean {
    return this.control ? !this.control.valid && this.control.touched : false;
  }

  controlHasError(error: string): boolean {
    return this.control ? this.control.hasError(error) : false;
  }
  onChange(event: any): void {
    this.change.emit(event);
  }

  onScrollToEnd(): void {
    this.scrollToEnd.emit();
  }
}
